<template>
  <div class="eigyou-user-id edit-item" v-if="editingData && options">

    <div class="head"><b>担当営業者</b></div>
    <div class="data">
      <select-box v-if="eigyouList"
      :options="eigyouList" v-model="editingData.eigyou_user_id" class="medium"
      :error="getError(editingData, 'eigyou_user_id')" :disabled="disabled"></select-box>
      <p class="current-data">{{ currentData?.eigyou_user_name ? currentData?.eigyou_user_name : '-'}}</p>
    </div>

  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { useKoyouKeiyakuEdit } from '@/composable/koyoukeiyaku/edit';
import { KoyouKeiyakuOption } from '@/types/KoyouKeiyaku';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent, onMounted } from 'vue';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    options: {
      type: Object as () => KoyouKeiyakuOption | null,
      require: true,
      default: null,
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();

    const { getKoyouKeiyakuEigyouUser, eigyouList } = useKoyouKeiyakuEdit();

    onMounted(async () => {
      // 所属IDからユーザーの基本情報オプション値を取得
      await getKoyouKeiyakuEigyouUser()  
    })

    return {
      getError,
      eigyouList,
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>
